exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".collapsed-card .card-header{border-bottom:0}.add-vendor-message{color:#919191;font-style:italic;text-align:justify;max-width:420px;margin-left:auto;line-height:1.5;white-space:normal;margin-top:-30px;font-size:16px;font-weight:600}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-lookup-form/vendor-lookup-form.component.css"],"names":[],"mappings":"AAAA,6BACI,eAAiB,CACpB,oBAEC,cAAe,kBACI,mBACC,gBACH,iBACC,gBACD,mBACG,iBACF,eACF,eACC,CAClB","file":"vendor-lookup-form.component.css","sourcesContent":[".collapsed-card .card-header {\n    border-bottom: 0;\n}\n.add-vendor-message {\n  color: #919191;\n  font-style: italic;\n  text-align: justify;\n  max-width: 420px;       /* optional: control wrapping width */\n  margin-left: auto;      /* align right inside flex or block */\n  line-height: 1.5;\n  white-space: normal;    /* ensures wrapping works */\n  margin-top: -30px;\n  font-size: 16px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-lookup-form/vendor-lookup-form.component.css
// module id = /Y8/
// module chunks = 0